import { render, staticRenderFns } from "./subjunktioner.vue?vue&type=template&id=061802a5&scoped=true"
import script from "./subjunktioner.vue?vue&type=script&lang=js"
export * from "./subjunktioner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061802a5",
  null
  
)

export default component.exports